export const validate = {
  methods: {
    delNumbers(e) {
      if(e.keyCode != 32) {
        let regex = new RegExp("^[a-zA-Zа-яА-Я]+$");
        let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!regex.test(key)) {
          e.preventDefault();
          return false
        };
      }
    },
    delString(e) {
      let regex = new RegExp("[0-9]+$");
      let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (!regex.test(key)) {
        e.preventDefault();
        return false
      }
    },
  }
}
